import { useAuth0 } from '@auth0/auth0-react';
import { faBars, faChartLine, faCodeBranch, faHardHat, faRoute, faSignOut } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import logo from '../assets/images/oa.png';

export const Navigation = () => {
  const [navigationOpen, setNavigationOpen] = useState(false);

  const { logout, isAuthenticated } = useAuth0();

  return (
    <>
      <nav className="relative flex flex-wrap items-center justify-between px-2 py-3 bg-teal-600 mb-3">
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between sm:w-auto sm:static sm:block sm:justify-start">
            <Link
              to="/"
              className="px-3 py-2 flex items-center text-2xl font-bold leading-snug text-white hover:opacity-75"
            >
              <img src={logo} alt="Bioplan Logo" className="h-10 text-lg leading-lg text-white opacity-75" />
              <span className="ml-2">Bioplan Admin</span>
            </Link>
            <button
              className="text-white cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block sm:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavigationOpen(!navigationOpen)}
            >
              <FontAwesomeIcon icon={faBars} />
            </button>
          </div>
          <div
            className={'sm:flex flex-grow items-center' + (navigationOpen ? ' flex' : ' hidden')}
            id="example-navbar-danger"
          >
            <ul className="flex flex-col sm:flex-row list-none sm:ml-auto">
              <li className="nav-item">
                <Link
                  className="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75"
                  to="/prod"
                >
                  <FontAwesomeIcon
                    icon={faRoute}
                    aria-hidden={true}
                    className="text-lg leading-lg text-white opacity-75"
                  />
                  <span className="ml-2">Production</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75"
                  to="/optimizer"
                >
                  <FontAwesomeIcon
                    icon={faChartLine}
                    aria-hidden={true}
                    className="text-lg leading-lg text-white opacity-75"
                  />
                  <span className="ml-2">Optimizer</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75"
                  to="/dev"
                >
                  <FontAwesomeIcon
                    icon={faCodeBranch}
                    aria-hidden={true}
                    className="text-lg leading-lg text-white opacity-75"
                  />
                  <span className="ml-2">Development Environments</span>
                </Link>
              </li>
              {/**
               <li className="nav-item">
               <Link
               className="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75"
               to="/benchmarks"
               >
               <FontAwesomeIcon icon={faMagnifyingGlassChart} className="text-lg leading-lg text-white opacity-75" />
               <span className="ml-2">Benchmarks</span>
               </Link>
               </li>
               */}
              {isAuthenticated && (
                <li className="nav-item">
                  <button
                    className="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75"
                    type="button"
                    onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
                  >
                    <FontAwesomeIcon icon={faSignOut} className="text-lg leading-lg text-white opacity-75" />
                    <span className="ml-2">Sign out</span>
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};
